import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Checkbox from '@cotyorg/ccx-atoms/Checkbox';

export const getOnChange = ({ toggleFilter, categoryName, optionName }) => () => {
  toggleFilter({ categoryName, optionName });
};

export const generateLabelClassNames = ({ isDisabled } = {}) => (
  classNames(
    'filter__option-label',
    'cell',
    'auto', {
      'filter__option-label--is-disabled': isDisabled,
    },
  )
);

export const generateProductCountClassNames = ({ isDisabled } = {}) => (
  classNames(
    'filter__product-count',
    'cell',
    'shrink', {
      'filter__product-count--is-disabled': isDisabled,
    },
  )
);

export const generateID = ({ categoryName = '', optionName = '' }) => (
  `filter-option-${categoryName}-${optionName}`
);

export const isDisabled = count => count === 0;

const CategoryOption = ({
  categoryName,
  optionName,
  count,
  color,
  isSelected,
  toggleFilter,
  showProductCount,
}) => (
  <div className="filter__category-option grid-x">
    <div className="cell shrink">
      <Checkbox
        disabled={isDisabled(count)}
        name={generateID({ categoryName, optionName })}
        id={generateID({ categoryName, optionName })}
        onChange={getOnChange({ toggleFilter, categoryName, optionName })}
        checked={isSelected}
      />
    </div>
    <label
      className={generateLabelClassNames({ isDisabled: isDisabled(count) })}
      htmlFor={generateID({ categoryName, optionName })}
    >
      {optionName}
    </label>
    { color && (
      <div className="cell shrink">
        <div className="filter__color-swatch" style={{ backgroundColor: color }} />
      </div>
    )}
    {showProductCount && <p className={generateProductCountClassNames({ isDisabled: isDisabled(count) })}>({count})</p>}
  </div>
);

CategoryOption.propTypes = {
  categoryName: PropTypes.string.isRequired,
  optionName: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  color: PropTypes.string,
  isSelected: PropTypes.bool.isRequired,
  toggleFilter: PropTypes.func.isRequired,
  showProductCount: PropTypes.bool.isRequired,
};

export default CategoryOption;
